import { useCreatorBulkUploadItems } from '@round/creatorbase-helpers/api-hooks';
import { useCreatorAccountRows } from '../../hooks/useCreatorAccountRows';

// The backend caps an upload at 500 rows (`MAX_UPLOAD_ROWS`), so a page this size holds all of them in one
// request.
const ITEMS_PAGE_SIZE = 500;

/**
 * Every item of the upload in one request, each paired with its account as Creator Explore has it. The
 * list and the pool picker in it both read the rows from here, so the screen asks for the items once.
 */
export function useBulkUploadItemRows(bulkUploadId: number) {
    const list = useCreatorBulkUploadItems(
        bulkUploadId,
        { page_size: ITEMS_PAGE_SIZE },
        // An upload can finish processing while its cached items are still fresh, and the screen does not
        // poll, so opening it again always asks for where the upload has got to.
        { refetchOnMount: 'always' }
    );

    // Only a created item has a creator to look up, the others have no ids yet.
    const { rows, isExploreLoading, isImagesLoading } = useCreatorAccountRows(list.items);

    return {
        rows,
        isLoading: list.isLoading,
        isExploreLoading,
        isImagesLoading,
        isError: list.isError,
        errorMessage: list.errorMessage,
    };
}
